<template>
  <div :class="bindInputClass">
    <input
      id="email-input"
      ref="email-input"
      v-model="emailValue"
      autocomplete="off"
      type="email"
      inputmode="email"
      :placeholder="$t('common.email')"
      @input="handleInput"
      @blur="handleBlur"
      @focus="handleFocus"
      @keyup.enter="handleBlur"
      :class="bindEmailClass"
      :style="bindInputStyle"
    />
    <p class="tips-text">{{ $t('publicDetails.detail_email_tip') }}</p>
    <div class="check-info">
      <img
        class="error"
        v-show="validator.isError"
        :src="require('@/assets/images/detail/uid_error.png')"
        alt="error"
        @click.stop="handleIcon"
        @mousedown="handleMousedown"
      />
      <img
        class="success"
        v-show="validator.isSuccess"
        :src="require('@/assets/images/detail/common/success.png')"
        alt="success"
      />
      <van-loading
        v-show="validator.isLoading"
        type="spinner"
        class="loading-icon"
      />
    </div>
  </div>
</template>

<script>
  import { hexToRgba } from '@/utils/hexToRgba'
  import styleConfiguration from '@/mixins/detail/styleConfiguration'
  import { mapMutations, mapState } from 'vuex'
  import { queryOrderEmail } from '@/api/games'
  import isEmpty from 'lodash/isEmpty'
  import { emailReg } from '@/utils/regExp'

  export default {
    mixins: [styleConfiguration],
    data() {
      return {
        emailValue: '',
        validator: {
          isInInput: false, // 是否在输入中
          isError: false, // 验证错误
          isSuccess: false, // 验证成功
          isLoading: false, // 验证中
        },
      }
    },
    mounted() {
      this.loadEmail()
    },
    watch: {
      userInfo: {
        handler(newVal) {
          if (isEmpty(newVal)) return
          this.loadEmail()
        },
        deep: true,
        immediate: true,
      },
    },
    computed: {
      ...mapState(['userInfo']),
      ...mapState('detail', ['notificationEmail']),
      bindInputClass() {
        const defaultClass = ['input-email']
        let device = []

        if (this.isDesktop) {
          device.push(`${defaultClass[0]}-desktop`)
        }
        if (this.isMobile) {
          device.push(`${defaultClass[0]}-mobile`)
        }
        if (
          (this.serverList && this.serverList.length) ||
          this.isRenderCheckffuid
        ) {
          device.push(`${defaultClass[0]}-server`)
        }
        return defaultClass.concat(device)
      },
      bindEmailClass() {
        const classNames = ['input', this.gameName]
        let classTypes = []
        if (this.validator.isInInput) {
          classTypes.push('in-input')
        }
        if (this.validator.isError) {
          classTypes.push('error-input')
        }
        if (this.validator.isSuccess) {
          classTypes.push('success-input')
        }
        if (this.isDesktop) {
          classTypes.push('desktop-input')
        }
        return classNames.concat(classTypes)
      },
      bindInputStyle() {
        return {
          backgroundColor: this.skuBackColor.backgroundColor,
          borderColor: this.skuBackColor.borderColor,
          color: this.mFontColor.color,
          '--placeholderColor': hexToRgba(this.mFontColor.color),
        }
      },
    },
    methods: {
      ...mapMutations([
        'detail/setNotificationEmail',
        'detail/setUidValidator',
      ]),
      handleInput() {
        this.handleBlur()
      },
      async handleBlur() {
        this['detail/setNotificationEmail'](this.emailValue)
        if (emailReg.test(this.emailValue)) {
          this.handleCheck({ isLoading: false, isSuccess: true })
        } else {
          this['detail/setUidValidator']({
            customTips: 'publicDetails.detail_email_error_tip',
          })
          this.handleCheck({ isLoading: false, isError: true })
        }
      },
      handleFocus() {},
      handleCheck({
        isInInput = false,
        isError = false,
        isSuccess = false,
        isLoading = false,
      } = {}) {
        this.validator = {
          isInInput,
          isError,
          isSuccess,
          isLoading,
          showIcon: false,
        }
        this['detail/setUidValidator'](this.validator)
      },
      handleIcon() {
        this.emailValue = ''
        this.$nextTick(() => {
          this.$refs['email-input']['focus']()
          this.handleCheck()
        })
      },
      handleMousedown(event) {
        event.preventDefault()
      },
      loadAccountEmail() {
        if (this.userInfo && this.userInfo.email) {
          this.emailValue = this.userInfo.email
        }
      },
      loadEmail() {
        // 存在输入的邮箱内容，优先显示用户已输入的内容；这个值在每次进入详情页是空的；用于在详情页登录的情况
        if (!isEmpty(this.notificationEmail)) {
          this.emailValue = this.notificationEmail
          return
        }
        // 登录状态下去获取绑定的邮箱
        if (this.userInfo) {
          if (this.userInfo.email) {
            this.emailValue = this.userInfo.email
            this.handleBlur()
          } else {
            queryOrderEmail()
              .then((response) => {
                const { email } = response
                // 下单默认传入toplupeservice@aptostar.com，不能是默认邮箱才能复写进输入框
                if (email && email !== 'toplupeservice@aptostar.com') {
                  this.emailValue = email
                  this.handleBlur()
                }
              })
              .catch(() => {})
          }
        }
      },
    },
  }
</script>

<style scoped lang="scss" src="./styles.scss"></style>
<style lang="scss" scoped>
  @media screen and (min-device-width: 1080px) {
    @import './styles_pc.scss';
  }
</style>
